import LayersIcon from "@mui/icons-material/Layers";

export const StackScrollToolConfig = {
  name: "STACK",
  tool: "StackScrollTool",
  icon: <LayersIcon/>,
};

